import { useEffect } from 'react';
import Animated, {
    cancelAnimation,
    Easing,
    useAnimatedStyle,
    useSharedValue,
    withRepeat,
    withTiming,
} from 'react-native-reanimated';
import {
    BanknoteIcon,
    BodyMediumRegular,
    H2Emphasized,
    Icon,
    isNonMobileWeb,
    ScreenContainer,
    View,
    YStack,
} from 'smoothie';

interface CheckDepositFlipProps {
    onDone: () => void;
}

const CheckDepositFlip = ({ onDone }: CheckDepositFlipProps) => {
    useEffect(() => {
        const timer = setTimeout(onDone, 2000);
        return () => {
            clearTimeout(timer);
        };
    }, [onDone]);
    const rotation = useSharedValue(0);

    useEffect(() => {
        rotation.value = withRepeat(
            withTiming(360, {
                duration: 4000,
                easing: Easing.linear,
            }),
            -1,
            false,
        );

        return () => {
            cancelAnimation(rotation);
            rotation.value = 0;
        };
    }, [rotation]);

    const rotatingStyle = useAnimatedStyle(() => ({
        transform: [{ perspective: 1000 }, { rotateY: `${rotation.value}deg` }],
    }));

    return (
        <ScreenContainer
            containerProps={{
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <YStack width="100%" alignSelf="center">
                <YStack
                    alignItems="center"
                    marginTop={isNonMobileWeb ? 50 : '30%'}
                    paddingHorizontal={24}
                >
                    <Animated.View style={rotatingStyle}>
                        <View
                            alignSelf="center"
                            padding={25}
                            borderRadius={20}
                            backgroundColor="$gray200"
                            marginTop={30}
                            marginBottom={30}
                        >
                            <Icon icon={BanknoteIcon} size={30} />
                        </View>
                    </Animated.View>
                    <H2Emphasized textAlign="center">
                        Flip the check over!
                    </H2Emphasized>
                    <BodyMediumRegular
                        textAlign="center"
                        color="$gray1000"
                        marginTop={8}
                        marginHorizontal={12}
                    >
                        Now capture the back of your check
                    </BodyMediumRegular>
                </YStack>
            </YStack>
        </ScreenContainer>
    );
};

export default CheckDepositFlip;
